import { FC, useEffect, useState } from "react";
import { LandingPageWrapper } from "./LandingPage.styled";
import { useParams } from "react-router-dom";
import { getLandingPageData } from "cms/helpers";
import { StructuredText } from "react-datocms";


interface Section {
  title: string;
  description: {
    value: any;
  };
  image: {
    url: string;
  };
}

interface LandingPageProps {}

const LandingPage: FC<LandingPageProps> = () => {
  const { slug } = useParams();
  const [landingPageData, setLandingPageData] = useState<any>(null);
  useEffect(() => {
    const fetchLandingPageData = async () => {
      const data = await getLandingPageData(slug || "");
      console.log(data);
      setLandingPageData(data);
    };
    fetchLandingPageData();
  }, [slug]);
  return(
    <LandingPageWrapper>
      <h1>{landingPageData?.title}</h1>
      <h4 className="intro-paragraph">{landingPageData?.introParagraph}</h4>
      <div className="sections-wrapper">
        {landingPageData?.sections?.map((section: Section, index: number) => {
          //if index is odd, reverse the order
          if (index % 2 === 1) {
            return (
              <div
                className="section-wrapper-right"
                id={`section-${index}`}
                key={index}
              >
                <div className="flex-wrapper-right">
                  <img src={section.image?.url} />
                  <div className="text-right">
                    <h2>{section.title}</h2>
                    <StructuredText data={section.description?.value} />
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div
                className="section-wrapper"
                id={`section-${index}`}
                key={index}
              >
                <div className="flex-wrapper">
                  <div className="text">
                    <h2>{section.title}</h2>
                    <StructuredText data={section.description?.value} />
                  </div>
                  <img src={section.image?.url} />
                </div>
              </div>
            );
          }
        })}
      </div>
    </LandingPageWrapper>
  );
};

export default LandingPage;
